import React from 'react'
import { Box, Link } from '@mui/material'
import { styled } from '@mui/system'
import { Spinner } from 'packages/eid-ui'

const StyledActionButton = styled(Box)(
    ({
        theme,
        width,
        height,
        padding,
        bgColor,
        hoverColor,
        border,
        fontColor,
        disabled,
    }) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '0.5rem',
        width: width,
        height: height,
        padding: padding,
        backgroundColor: disabled ? '#d0d9e2' : bgColor,
        border: border,
        color: fontColor || '#ffffff',
        '&:hover': {
            cursor: disabled ? 'initial' : 'pointer',
            backgroundColor: hoverColor,
        },
    }),
)

const ActionButton = (props) => {
    const {
        width,
        height,
        padding,
        bgColor,
        hoverColor,
        border,
        fontColor,
        children,
        loading,
        onClick,
        disabled,
        loaderColor,
    } = props

    return (
        <Link
            component="button"
            underline="none"
            onClick={disabled ? undefined : onClick}
            style={{ width: width ? width : '100%' }}
        >
            <StyledActionButton
                width={width}
                height={height}
                padding={padding}
                bgColor={bgColor}
                border={border}
                fontColor={fontColor}
                hoverColor={hoverColor}
                disabled={disabled}
            >
                {loading && <Spinner size={0.8} color={loaderColor} />}
                {!loading && children}
            </StyledActionButton>
        </Link>
    )
}

ActionButton.defaultProps = {
    width: '10rem',
    height: '4.8rem',
    bgColor: '#ffffff',
    border: 'none',
    loaderColor: '#ffffff',
    padding: '0 0.8rem',
}

export default ActionButton
